import React, { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button } from '@material-ui/core';
import { Pagination, STableLoader, FilterComponent, PageLoader, EmptyCollection } from '../../shared_elements';
import { TechSpecsNav } from '../../elements'
import { AssetInfo } from "../components";
import { globalExportService, globalGetService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import useAssetInfo from '../hooks/useAssetInfo';
import moment from "moment";
import { assetTypeValues, backendDateFormat, displayDateFormat, fieldDateFormat } from "../../../constants";
import { downloadFileType, numberWithCommas } from "../../../utils";
import { getPermissionKey } from "..";
import { trackActivity } from "../../../utils/mixpanel";
import {  SaveAlt } from '@material-ui/icons';
const HDR_ROW1_HEIGHT = 60;
const MovementTrackerHd = () => {
    return (
        <TableHead>
            <TableRow style={{ height: HDR_ROW1_HEIGHT }}>
                <TableCell rowSpan={2}>Asset</TableCell>
                <TableCell rowSpan={2}>Status</TableCell>
                <TableCell rowSpan={2}>Performed By</TableCell>
                <TableCell rowSpan={2}>Performed At</TableCell>
                <TableCell rowSpan={2}>Position</TableCell>
                <TableCell style={{ width: '250px' }} colSpan={3} align="center">Installed/Removed Details</TableCell>
                <TableCell rowSpan={2} style={{ width: '90px' }}>Is Billable</TableCell>
                <TableCell rowSpan={2} style={{ width: '150px' }}>Reason</TableCell>
                <TableCell rowSpan={2} style={{ width: '145px' }}>Records Movement</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ top: HDR_ROW1_HEIGHT }}>Date</TableCell>
                <TableCell style={{ top: HDR_ROW1_HEIGHT }}>TSN</TableCell>
                <TableCell style={{ top: HDR_ROW1_HEIGHT }}>CSN</TableCell>
            </TableRow>
        </TableHead>
    )
}
const MovementTrackerList = ({ item, assetInfoData }) => {
    const [showMore, setShowMore] = useState({});
    const toggleDescription = (id) => {
        setShowMore({
            ...showMore,
            [id]: !showMore[id],
        });
    };
    return (
        <TableRow>
            <TableCell>{ (assetInfoData?.asset_type?.type === 1 ? item?.major_assembly?.asset_name :item?.aircraft?.asset_name ) || '--'}</TableCell>
            <TableCell>{item?.status?.label || '--'} {item?.installed_type ? `(${item?.installed_type})` : null}</TableCell>
            <TableCell>{item?.user?.name || ''}</TableCell>
            <TableCell>{moment(item.created_at).format(displayDateFormat) || '--'}</TableCell>
            <TableCell>{item?.position?.label || '--'}</TableCell>
            <TableCell>{item.as_of_date ? moment(item.as_of_date).format(displayDateFormat) : '--'}</TableCell>
            <TableCell>{numberWithCommas(item?.tsn)}</TableCell>
            <TableCell>{numberWithCommas(item?.csn)}</TableCell>
            <TableCell>{item?.is_billable ? 'Yes' : 'No'}</TableCell>
            <TableCell>
                {item?.remarks && item?.remarks?.length > 50 ? (
                    <div style={{ width: '300px' }}>
                        {showMore[item?.id] ? (
                            <span> {item?.remarks}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.id); }}  >less </a>
                            </span>
                        ) : (
                            <span> {item.remarks.substring(0, 35)}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.id); }}  > ..more </a>
                            </span>
                        )}
                    </div>
                ) : (
                    <span>{item.remarks || '--'}</span>
                )}
            </TableCell>
            <TableCell >{item?.is_data_moved ? 'Yes': 'No'}</TableCell>
        </TableRow>
    )
}
const MovementTracker = ({ params }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [movementTrackerInfo, setMovementTrackerInfo] = useState({ list: [], pagination: {} });
    const [filter, setFilter] = useState({});
    const { assetInfoData, assetSkeletonLoader, refreshAssetInfo } = useAssetInfo(params.type, params.aircraft_slug);
    useEffect(() => {
        getMovementTracker({per_page:50}, 'skeletonLoader');
    }, []);
    const getMovementTracker = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/get-major-assembly-history/${params.type}/${params.aircraft_slug}/?page=1`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setMovementTrackerInfo(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onMOmentExport = () => {
        setLoading(true);
        globalExportService(`console/get-major-assembly-history/${params.type}/${params.aircraft_slug}/?download=xlsx`)
            .then(response => {
                downloadFileType(response, `${assetTypeValues[assetInfoData?.asset_type.type].label} ${assetInfoData.serial_number} Moment-Tracker ${moment().format(fieldDateFormat)}`, 'xlsx')
                trackActivity('Console Management', { page_title: 'MovementTracker', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Exported', event_desc: 'Movement Tracker Exported Successfully', file_extension: 'xlsx' });
                // enqueueSnackbar("MomentTracker Exported Successully", { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                setLoading(false);
            })
    }
    return (
        <section className="asset-tech-specs">
            <AssetInfo assetInfoData={assetInfoData} skeletonLoader={assetSkeletonLoader} getResponseBack={refreshAssetInfo} />
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 162}px` }}>
                <TechSpecsNav />
                <div className="tech-specs-content" >
                    <div style={{ padding: '0px 10px' }}>
                        {skeletonLoader ? <STableLoader count={5} /> :
                            <>
                                <Paper elevation={0} className="console-paper" style={{ padding: '4px 8px' }}>
                                    <Grid container spacing={1} alignItems="center">
                                        <Grid item md={9}></Grid>
                                        <Grid item md={3}>
                                            <ul className="list-inline flex-centered" style={{ float: 'right' }}>
                                                {checkPermission('technical_specs', getPermissionKey(params.type), 'EXP') ?
                                                    <li className="list-inline-item">
                                                        <Button onClick={onMOmentExport} disabled={!movementTrackerInfo?.list?.length } color='primary' size='small' variant="outlined" startIcon={<SaveAlt style={{ fontSize: '1.2rem' }} />}>Export</Button>
                                                    </li> : null}
                                            </ul>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                <Paper square>
                                    <div style={{height:`${window.innerHeight -  (movementTrackerInfo?.list?.length ? 280 : 225)}px`,overflow:'auto',marginTop: "3px"}}>
                                    <Table className='mui-table-format' stickyHeader>
                                        <MovementTrackerHd />
                                        <TableBody>
                                            {movementTrackerInfo?.list?.map((item, index) =>
                                                <MovementTrackerList
                                                assetInfoData={assetInfoData}
                                                    key={index}
                                                    item={item}
                                                />
                                            )}
                                        </TableBody>
                                    </Table>
                                      {!movementTrackerInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                    </div>
                                </Paper>
                                <Paper square>
                                    <Pagination
                                        pagination={movementTrackerInfo.pagination}
                                        onChangePage={(event, newPage) => getMovementTracker({ ...filter, page: newPage + 1, per_page: movementTrackerInfo.pagination.per_page }, 'pageLoader')}
                                        onChangeRowsPerPage={(event) => getMovementTracker({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                                    />
                                </Paper>
                            </>
                        }
                        {isLoading ? <PageLoader /> : null}
                    </div>
                </div>
            </Paper>
        </section>
    )
}
export default MovementTracker;